module.exports = __webpack_public_path__ + "static/media/file.76bdb8ac.svg";